module.exports = __webpack_public_path__ + "img/p4-pic.2caf3e58.jpg";